import keyMirror from 'keymirror';

export const manageEpisodeActionTypes = keyMirror({
	TOGGLE_MANAGE_EPISODE_MODAL: null,

	GET_ADMIN_EPISODE_DATA_REQUEST: null,
	GET_ADMIN_EPISODE_DATA_SUCCESS: null,
	GET_ADMIN_EPISODE_DATA_ERROR: null,

	MANAGE_ADMIN_EPISODE_REQUEST: null,
	MANAGE_ADMIN_EPISODE_SUCCESS: null,
	MANAGE_ADMIN_EPISODE_ERROR: null,

	CLEAN_MANAGE_EPISODE_STATE: null,
});
